export const containers =[
	{type:'45"',weight:4800 },
	{type:'40"',weight:3900 },
	{type:'20"',weight:2900 },
	{type:'30"',weight:3200 },
];
